const Role = {
    mmpladmin: 'admin',
    client: 'client',
    mmpl: 'mmpl',
    staff: 'staff',
}
export default Role;